import React from 'react';
import styled from 'styled-components';
import { getPageMessage } from '../../shared/constants/pageMessages';

const EmptyTextViewer: React.FC = () => {
  return (
    <EmptyTextViewerContainer>
      {getPageMessage('SELECT_TEXT_TO_VIEW')}
    </EmptyTextViewerContainer>
  );
};

export default EmptyTextViewer;

const EmptyTextViewerContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  
  border-left: 1px solid ${({ theme }) => theme.colors.color_Gray_06};
  border-right: 1px solid ${({ theme }) => theme.colors.color_Gray_06};
  ${({ theme }) => theme.typography.Body_03_2};
  user-select: none;
`;
